const safeZone = 3; // This "safe zone" is used to make sure we trigger when the user hits the bottom of the element.

export const isBottomDiv = (el: HTMLDivElement) =>
    Math.ceil(el.scrollHeight - el.scrollTop) <= el.clientHeight + safeZone;
